export const urls = {
  GET_PONUDE: 'DokPonude/ponude_pregled_sa_filterom',
  INSERT_PONUDE: 'DokPonude/unos_dok_ponude',
  EDIT_PONUDE: 'DokPonude/izmena_dok_ponude',
  GET_PONUDE_ID: 'DokPonude/vrati_dok_ponude_za_id',
  DELETE_PONUDE: 'DokPonude/brisanje_dok_ponude',
  KONVERTOVANJE_BASE_64: 'DokPonude/konvertovanje_base64_sa_id_ponude',

  GET_STATUSI_COMBO: 'Combo/vrati_statuse_ponude',
  GET_MASINE_COMBO: 'Combo/vrati_masine_combo',
  GET_SL_BROJ_PONUDE: 'DokPonude/vrati_sledeci_br_dok_za_ponude',
};
